import FontIcon from '../FontIcon';
import React from 'react';
import { IconSize } from '../types';
import LoadingSpinner from '../LoadingSpinner';
import bemBlock from '@gik/core/utils/bemBlock';

const blockName = `popover-list-item`;

export interface PopoverListItemProps {
  prepend: JSX.Element;
  icon?: string;
  hover?: boolean;
  danger?: boolean;
  onClick(): void;
  iconSize?: IconSize;
  isLoading?: boolean;
  className?: string;
}

export default function PopoverListItem({
  prepend,
  icon,
  onClick,
  hover,
  danger,
  iconSize = 'sm',
  isLoading,
  className,
}: PopoverListItemProps): React.ReactElement {
  const bem = bemBlock(blockName);

  return (
    <div
      className={bem(
        null,
        [
          {
            hover: hover,
          },
          {
            danger: danger,
          },
          {
            loading: isLoading,
          },
        ],
        className
      )}
      onClick={onClick}
    >
      {prepend}
      {isLoading ? <LoadingSpinner /> : icon ? <FontIcon name={icon} size={iconSize} /> : null}
    </div>
  );
}
